export default __webpack_public_path__ + "static/158-52149cc69d5162679c0e1ca93c310d51.jpg";